<template>
  <form action="#">
    <span v-html="params.sessid"></span>
    <div class="row form-group">
      <div class="col-12">
        <div class="form-group__input">
          <div class="input-placeholder" :class="!name.length ? 'error' : ''">
            <input id="first_name" type="text" class="form-input" v-model="name" :class="name.length ? 'focus' : ''">
            <label for="first_name">{{params.name}}</label>
            <span class="error">{{params.errorText}}</span>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group__input">
          <div class="input-placeholder" :class="!email.length ? 'error' : ''">
            <input id="customer_email" type="email" class="form-input" v-model="email" :class="email.length ? 'focus' : ''">
            <label for="email">{{params.email}}</label>
            <span class="error">{{params.errorText}}</span>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group__input">
          <div class="input-placeholder" :class="!phone.length ? 'error' : ''">
            <input type="tel" id="customer_phone" class="form-input" v-model="phone" :class="phone.length ? 'focus' : ''">
            <label for="customer_phone">{{params.phone}}</label>
            <span class="error">{{params.errorText}}</span>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group__input">
          <div class="input-placeholder" :class="!question.length ? 'error' : ''">
            <input type="text" id="customer_question" class="form-input" v-model="question" :class="question.length ? 'focus' : ''">
            <label>{{params.question}}</label>
            <span class="error">{{params.errorText}}</span>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group__input">
          <div class="g-recaptcha" :data-sitekey="params.recaptchaKey"></div>
        </div>
      </div>
      <div class="col-12 text-center success-text" v-show="sentForm">{{params.successText}}</div>
      <div class="col-12 text-center">
        <button @click.prevent="send();" type="submit" :disabled="disabled" class="btn btn--fill">{{params.send}}</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "contacts-form",
  selector: "#contacts-form",
  props: {
    params: Object
  },
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      question: '',
      sentForm: false,
      disabled: false
    };
  },
  methods: {
    send() {
      let hasError = false,
          captcha = grecaptcha.getResponse();
      const requestParams = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        question: this.question,
        sessid: document.querySelector('#contacts-form [name="sessid"]').value,
        handler: "contacts",
        func: "formAdd",
        'g-recaptcha-response': captcha
      };

      const propMap = {
        'name': '#first_name',
        'email': '#customer_email',
        'phone': '#customer_phone',
        'question': '#customer_question',
      };

      for (const [prop, selector] of Object.entries(propMap)) {
        if (!requestParams[prop].length) {
          hasError = true;
          document.querySelector('#contacts-form ' + selector).parentElement.classList.add('error')
        } else {
          document.querySelector('#contacts-form ' + selector).parentElement.classList.remove('error')
        }
      }

      if (!captcha.length) {
        hasError = true
      }

      if (!hasError) {
        this.disabled = true
        axios.post(window.App.AJAX_DIR, requestParams).then((response) => {
          if (response.data.status === "error") {
            for (const [prop, mess] of Object.entries(response.data.message)) {
              if (typeof propMap[prop] !== 'undefined') {
                document.querySelector('#contacts-form ' + propMap[prop]).parentElement.classList.add('error')
                document.querySelector('#contacts-form ' + propMap[prop]).nextElementSibling.nextElementSibling.innerHTML = mess
              } else {
                alert(mess)
              }
            }
          } else {
            this.sentForm = true
            for (const [prop, selector] of Object.entries(propMap)) {
              this[prop] = '';
            }
          }
          this.disabled = false
          grecaptcha.reset();
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .contacts-form {
    .form-group__input {
      margin-bottom: 30px;
    }

    .input-placeholder {
      position: relative;
    }

    .form-input {
      background-color: transparent;
      border: 0;
      border-bottom: 1px solid #b7b8b9;
      border-radius: 0;
      color: #27251f;
      display: block;
      font-size: 13px;
      height: 33px;
      line-height: 200%;
      //margin-bottom: 30px;
      outline: none;
      padding: 0 0 4px;
      resize: none;
      width: 100%
    }

    .input-placeholder label {
      font-size: 13px;
      left: 0;
      line-height: 200%;
      pointer-events: none;
      position: absolute;
      top: 0;
      -webkit-transform: translateY(0);
      -moz-transform: translateY(0);
      -ms-transform: translateY(0);
      transform: translateY(0);
      -webkit-transition: .1s ease-in-out;
      -moz-transition: .1s ease-in-out;
      transition: .1s ease-in-out
    }

    .btn.btn--fill {
      background-color: #f2a1b2;
    }

    .btn {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      color: #27251f;
      cursor: pointer;
      display: inline-block;
      font-size: 14px;
      font-weight: 400;
      letter-spacing: .15em;
      line-height: 1.3;
      min-width: 280px;
      padding: 20px 0;
      position: relative;
      text-align: center;
      -webkit-text-decoration: none;
      text-decoration: none;
      text-transform: uppercase;
      -webkit-transition: .1s ease-in-out;
      -moz-transition: .1s ease-in-out;
      transition: .1s ease-in-out
    }

    .btn:before {
      border: 1px solid #f2a1b2;
      border-radius: 2px;
      bottom: 0;
      content: "";
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      -webkit-transition: .1s ease-in-out;
      -moz-transition: .1s ease-in-out;
      transition: .1s ease-in-out
    }

    .btn:hover:before {
      border-width: 2px
    }
    .btn:focus {
      box-shadow: none;
    }
    .input-placeholder input.focus+label,
    .input-placeholder input:focus+label {
      font-size:10px;
      line-height:130%;
      -webkit-transform:translateY(-.85rem);
      -moz-transform:translateY(-.85rem);
      -ms-transform:translateY(-.85rem);
      transform:translateY(-.85rem)
    }

    .input-placeholder .error {
      display: none;
      color: #d14432;
      font-size: 10px;
      line-height: 130%;
      margin-top: 4px;
    }
    .input-placeholder.error .error {
      display: block;
    }
    .success-text {
      padding: 10px 0 20px 0;
      font-weight: bold;
    }
  }
</style>